import React from 'react';
import { Segment, Button, Icon, Confirm, Message, Checkbox, Form, Input, Divider, List } from 'semantic-ui-react'
import { PANELCHANGER_BASEURL } from '../../../constants/system'
import RequestView from '../../rsm/dashboard/subcomponents/RequestView'

/**
 * Request and changes component
 */
export default class RequestsAndChanges extends React.Component {

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
            selectedVisitorTerritory: '-',
			open: false,
			isPanelOpen: undefined,
			showPanelConsent: '',
			lockoutSearch: '',
			lockouts: [],
			lockoutsLoading: true,
			lockoutsError: undefined,
			clearingLockoutUser: undefined
        }
	}

	handlePanelChangeIsOpen = (e) => { this.props.setSetting('isPanelOpen', !this.state.isPanelOpen) }

	handleShowPanelConsentChange = (e) => { this.setState({ ...this.state, showPanelConsent: e.target.value }) }

	handleSaveShowPanelConsent = () => { this.props.setSetting('showPanelConsent', this.state.showPanelConsent) }

	handleShowConfirm = () => this.setState({ open: true })
	handleCloseConfirm = () => this.setState({ open: false })
	handleConfirmed = () => { this.setState({ open: false }); this.handleExportAndProcess() }

	/**
	 * Export and close
	 */
	handleExportAndProcess() {
		window.location.href = PANELCHANGER_BASEURL + '/export/panelAndClose?token=' + localStorage.getItem('token');
	}

	/**
	 * Export new panel based on requests and panel chagnges (WITHOUT closing requests)
	 */
	openExportNewPanel() {
		window.location.href = PANELCHANGER_BASEURL + '/export/panel?token=' + localStorage.getItem('token');
	}

	/**
	 * Open raw export Excel
	 */
	openExportRaw() {
		window.location.href = PANELCHANGER_BASEURL + '/export/raw?token=' + localStorage.getItem('token')
	}

	/**
	 * Initialize
	 */
	componentDidMount() {
		this.props.clearSettingUi();
		this.props.clearRequestUi();
		this.props.clearPanelChangeUi();
		this.props.fetchSettings();
		this.props.fetchUsers();
		this.fetchLockouts();
	}

	handleLockoutSearchChange = (e) => { this.setState({ lockoutSearch: e.target.value }); }

	fetchLockouts = () => {
		const token = localStorage.getItem('token');
		const q = (this.state.lockoutSearch || '').trim();
		const url = PANELCHANGER_BASEURL + '/security/lockouts' + (q ? '?name=' + encodeURIComponent(q) : '');
		this.setState({ lockoutsLoading: true, lockoutsError: undefined });
		fetch(url, { headers: { 'Token': token } })
			.then((r) => {
				if (r.status === 401) throw new Error('Nincs jogosultság.');
				if (!r.ok) throw new Error('Hiba a listázás során (' + r.status + ').');
				return r.json();
			})
			.then((lockouts) => this.setState({ lockouts, lockoutsLoading: false }))
			.catch((e) => this.setState({ lockoutsError: e.message, lockoutsLoading: false }));
	}

	handleClearLockout = (username) => {
		this.setState({ clearingLockoutUser: username, lockoutsError: undefined });
		fetch(PANELCHANGER_BASEURL + '/security/lockouts/clear', {
			method: 'POST',
			headers: {
				'Token': localStorage.getItem('token'),
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ username })
		})
			.then((r) => {
				if (r.status === 401) throw new Error('Nincs jogosultság.');
				if (r.status === 404) {
					return r.json().then((j) => {
						throw new Error(j.message || 'Nincs ilyen zárolás.');
					});
				}
				if (!r.ok) throw new Error('Hiba a feloldás során (' + r.status + ').');
				return r.json();
			})
			.then(() => {
				this.setState({ clearingLockoutUser: undefined });
				this.fetchLockouts();
			})
			.catch((e) => this.setState({ clearingLockoutUser: undefined, lockoutsError: e.message }));
	}

	componentWillUnmount() {
		this.props.clearSettingUi();
		this.props.clearRequestUi();
		this.props.clearPanelChangeUi();
	}

    /**
     * Data update - maybe we have fetched day data?
     * @param {*} prevProps 
     */
    componentDidUpdate(prevProps) {
        const updates = {};
        if (prevProps.isPanelOpen !== this.props.isPanelOpen) {
            updates.isPanelOpen = this.props.isPanelOpen;
        }
        if (prevProps.showPanelConsent !== this.props.showPanelConsent) {
            updates.showPanelConsent = this.props.showPanelConsent;
        }
        if (Object.keys(updates).length > 0) {
            this.setState({ ...this.state, ...updates });
        }
    }
	
	/**
	 * Get all requests
	 */
	fetchRequests() {
		this.props.clearSettingUi();
		this.props.clearRequestUi();
		this.props.clearPanelChangeUi();
		this.props.fetchRequests(this.state.selectedVisitorTerritory);
		this.props.fetchPanelChanges(this.state.selectedVisitorTerritory);
	}

	render() {
		return  <Segment basic loading={ this.props.isLoading || this.props.isSaving }>
                    { this.props.error === undefined ? '' : <Message error>Hiba történt. { this.props.error }</Message> }
                    { this.props.errorPanelChange === undefined ? '' : <Message error>Hiba történt. { this.props.errorPanelChange }</Message> }
                    { this.props.errorRequest === undefined ? '' : <Message error>Hiba történt. { this.props.errorRequest }</Message> }
                    { this.state.lockoutsError === undefined ? '' : <Message error onDismiss={ () => this.setState({ lockoutsError: undefined }) }>{ this.state.lockoutsError }</Message> }
					<h3><Icon name='tasks'/>Orvoslátogatói Igények</h3>
					<br/>
					Kattints az <i>Export</i> gombra és Excelben letöltöd a változási igényekkel átalakított, legutóbb feltöltött Excel táblázatot.
					<br/>
					<br/>
					<Button onClick={ this.openExportNewPanel } floated='right' title='Elkészül az Excel, de a látogatók minden függő kérése függő is marad, nem zárjuk le azokat' primary basic><Icon name='download' /> Export</Button>
					<Button onClick={ this.openExportRaw } icon basic primary title='Minden, első naptól beérkezett kérés letöltése egyedi Excel formátumban'><Icon name='clock outline' /> Igények (nyers)</Button>
					<Segment color='red' padded>
						<p>
							<b>Figyelem!</b> Exportálás és zárás után a látogatók már nem tudják módosítani az igényeiket, azok véglegessé válnak.
						</p>
						<Button basic onClick={ this.handleShowConfirm } floated='right' title='Elkészül az Excel és minden függő kérést lezárunk'><Icon name='download' /> Export & Zárás</Button>
						<br/>
						<br/>
					</Segment>
					<Confirm
						open={ this.state.open }
						onCancel={ this.handleCloseConfirm }
						cancelButton='Mégsem'
						content='Biztosan zárod a látogatói igényeket?'
						confirmButton='Igen, zárok és exportálok'
						onConfirm={ this.handleConfirmed }
					></Confirm>
					<Divider />
					<h3><Icon name='ban'/>Zárolt fiókok (bejelentkezés)</h3>
					<p>
						Az SLR Light fiókok a sikertelen belépési kísérletek után automatikusan zárolódnak.
						Itt listázhatod és feloldhatod őket a Settings tábla kézi szerkesztése nélkül.
					</p>
					<Form>
						<Form.Group>
							<Form.Field width={6}>
								<Input
									placeholder='Szűrés névre…'
									value={this.state.lockoutSearch}
									onChange={this.handleLockoutSearchChange}
								/>
							</Form.Field>
							<Form.Button type='button' primary basic onClick={this.fetchLockouts} loading={this.state.lockoutsLoading}>
								<Icon name='refresh' /> Listázás
							</Form.Button>
						</Form.Group>
					</Form>
					{!this.state.lockoutsLoading && this.state.lockouts.length === 0
						? <Message info>Nincs zárolt fiók a megadott feltételek mellett.</Message>
						: ''}
					<List divided relaxed>
						{this.state.lockouts.map((l) => {
							const userName = l.username != null ? l.username : l.Username;
							const lockedUx = typeof l.lockedAtUnix === 'number' ? l.lockedAtUnix : l.LockedAtUnix;
							return (
							<List.Item key={userName}>
								<List.Content floated='right' verticalAlign='middle'>
									<Button
										basic
										primary
										size='small'
										loading={this.state.clearingLockoutUser === userName}
										disabled={this.state.clearingLockoutUser !== undefined && this.state.clearingLockoutUser !== userName}
										onClick={() => this.handleClearLockout(userName)}
									>
										Feloldom
									</Button>
								</List.Content>
								<List.Content>
									<List.Header>
										{userName || '—'}
									</List.Header>
									{typeof lockedUx === 'number' && !Number.isNaN(lockedUx) && (
										<List.Description>
											Zárolva: {new Date(lockedUx * 1000).toLocaleString('hu-HU')}
										</List.Description>
									)}
								</List.Content>
							</List.Item>
							);
						})}
					</List>
				<h3><Icon name='clock outline'/>Egyéni Panelváltoztatási Időszak</h3>
				<Checkbox onChange={ () => this.handlePanelChangeIsOpen() } checked={ this.state.isPanelOpen } toggle label='Panelváltoztatási lehetőség nyitva' />
				<Divider />
				<h3><Icon name='clipboard check'/>Panelnyilatkozat Beállítása</h3>
				<p>
					Add meg a ciklus nevét (pl. "2026C1"), amelyre a látogatóknak nyilatkozniuk kell a panelmódosítások véglegesítéséről. 
					Ha üresen hagyod, nem jelenik meg a nyilatkozati felszólítás a látogatók számára.
				</p>
				<Form>
					<Form.Group>
						<Form.Field width={4}>
							<Input 
								placeholder='pl. 2026C1'
								value={this.state.showPanelConsent}
								onChange={this.handleShowPanelConsentChange}
							/>
						</Form.Field>
						<Form.Button primary onClick={this.handleSaveShowPanelConsent}>
							<Icon name='save' />
							Mentés
						</Form.Button>
					</Form.Group>
				</Form>
				<Divider />
				<h3><Icon name='check'/>Egyedi Zárás</h3>
					<Form>
						<Form.Group widths='equal'>
							<Form.Dropdown 
								placeholder='Név szerint is kereshetsz'
								search
								selection
								onChange={ (e, {value}) => { this.setState({ ...this.state, selectedVisitorTerritory: value }); } }
								defaultValue={ this.state.selectedVisitorTerritory }
								options={this.props.users}/>
							<Form.Button primary onClick={ (e) => { e.preventDefault(); this.fetchRequests(); } } >Igénylista</Form.Button>
						</Form.Group>
					</Form>
					<RequestView setRequestProcessed={ this.props.setRequestProcessed } setPanelChangeProcessed={ this.props.setPanelChangeProcessed } requests={ this.props.requests } panelChanges={ this.props.panelChanges } allRequests={ [] } allPanelChanges={ [] } isAdmin={true} />
				</Segment>
	}
}